import React from "react";
import PersonView from "./PersonView";
import { Accordion, Card, Col, Row, Badge } from "react-bootstrap";
import moment from "moment";
import StudentController from "../api/StudentController";
import Loader from "react-loader";
import { connect } from "react-redux";
import { SortProvider } from "../services/SortingProvider";

interface AddressViewProps
{
    data: Address[];
    addressType: string;
}

interface AddressViewStates
{
    historicAddressesData: Address[];
    isLoading: boolean;
    openCurrent: boolean;
    openHistoric: boolean;
}

class AddressView extends React.Component<AddressViewProps, AddressViewStates>
{
    studentController: StudentController;
    sortProvider: SortProvider;

    constructor(props: AddressViewProps)
    {
        super(props);
        this.studentController = new StudentController();
        this.sortProvider = new SortProvider();

        this.state = {
            historicAddressesData: null,
            isLoading: true,
            openCurrent: true,
            openHistoric: false
        };
    }

    async getHistoricAddressesData()
    {
        const data = await this.studentController.getHistoricAddress();
        let filteredData = [];

        if (data)
        {
            this.sortProvider.sort(data.addresses, "Desc");

            if (this.props.addressType == "TR1")
            {
                filteredData = data.addresses.filter(itm => itm.addressType == "TR1" || itm.addressType == "TR2");
            }
            else
            {
                filteredData = data.addresses.filter(itm => itm.addressType == this.props.addressType);
            }
        }

        this.setState({
            isLoading: false,
            historicAddressesData: filteredData,
            openHistoric: !this.state.openHistoric
        });
    }

    render(): React.ReactNode 
    {
        const current = this.props.data[0];

        let privacyClass = "";

        if (this.props.settings.length > 0)
            privacyClass = (this.props.role == "academicAdvisor" && this.props.settings.filter(itm => itm.settingId == "psContactRoommates")[0].isActive == true) ? "d-none" : "";

        if (current)
        {
            if (current.street == null && current.city == null && current.state == null && current.country == null)
            {
                return <div className="text-center" id='error'>
                    <br />
                    <p className="error-text">No Addresses available</p>
                </div>;
            }
        }

        return <React.Fragment>
            <Accordion defaultActiveKey={"0"}>
                <Card>
                    <Accordion.Toggle href={"javascript:void(0)"} as={"a"} variant="link" eventKey="0" aria-expanded={this.state.openCurrent} onClick={() => this.setState({ openCurrent: !this.state.openCurrent })}>
                        <Card.Header>
                            <Row>
                                <Col xs={10}>
                                    <h3>
                                        <b>Current Address Information &nbsp;</b>
                                    </h3>
                                </Col>
                                <Col xs={1} className={"chevron"}>
                                    <h3><i className={this.state.openCurrent ? " far fa-chevron-up" : "far fa-chevron-down"}></i></h3>
                                </Col>
                            </Row>
                        </Card.Header>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            {
                                current
                                    ?
                                    <React.Fragment>
                                        <div className="darker-text">
                                            <Row>
                                                <Col>{current.street}</Col>
                                            </Row>
                                            <Row>
                                                <Col>{current.city}</Col>
                                            </Row>
                                            <Row>
                                                <Col>{current.state}</Col>
                                            </Row>
                                            <Row>
                                                <Col>{current.country}</Col>
                                            </Row>
                                        </div>
                                        {
                                            <div className={privacyClass + " mt-3 darker-text"}>
                                                {
                                                    (current.roomMates && current.roomMates.length > 0)
                                                    &&
                                                    <Row className={"mb-3"}>
                                                        <Col md="auto" className={"grayText"}>Current Roommates</Col>
                                                        {
                                                            <Col md="auto">
                                                                {
                                                                    current.roomMates.map((itm: Person, i: number) => 
                                                                    {
                                                                        return <PersonView data={itm} key={i} />;
                                                                    })
                                                                }
                                                            </Col>
                                                        }
                                                    </Row>
                                                }
                                            </div>
                                        }
                                    </React.Fragment>
                                    :
                                    <div className="text-center" id='error'>
                                        <br />
                                        <p className="error-text">No Current Addresses data available</p>
                                    </div>
                            }
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
            <Accordion className={"top-border"}>
                <Card>
                    <Accordion.Toggle href={"javascript:void(0)"} as={"a"} variant="link" eventKey="0" aria-expanded={this.state.openHistoric} onClick={() => this.getHistoricAddressesData()}>
                        <Card.Header>
                            <Row>
                                <Col xs={10}>
                                    <h3>
                                        <b>Historical Address Information &nbsp;
                                    {
                                                (this.state.historicAddressesData)
                                                &&
                                                <Badge pill style={{ opacity: "0.5" }} variant="secondary">{this.state.historicAddressesData.length}</Badge>
                                            }
                                        </b>
                                    </h3>
                                </Col>
                                <Col xs={1} className={"chevron"}>
                                    <h3><i className={this.state.openHistoric ? " far fa-chevron-up" : "far fa-chevron-down"}></i></h3>
                                </Col>
                            </Row>
                        </Card.Header>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            {
                                this.state.isLoading
                                    ?
                                    <div style={{ height: "100px", padding: "50px" }}>
                                        <Loader className={"spinner"} position={"relative"} scale={0.5} radius={15} corners={1} color={"#000"} opacity={0.25} rotate={0} direction={1} speed={1} trail={60} />
                                    </div>
                                    :
                                    <React.Fragment>
                                        {
                                            this.state.historicAddressesData.length > 0
                                                ?
                                                this.state.historicAddressesData.map((itm, i) => 
                                                {
                                                    return <div className={"darker-text address-item"} key={i}>
                                                        <Row>
                                                            <Col md={6}>
                                                                <Row>
                                                                    <Col>{itm.street}</Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>{itm.city}</Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>{itm.state}</Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>{itm.country}</Col>
                                                                </Row>
                                                            </Col>
                                                            <Col md={6}>
                                                                {moment(itm.fromDate).format("MMM YYYY")} - {moment(itm.thruDate).format("MMM YYYY")}
                                                            </Col>
                                                        </Row>
                                                        {
                                                            (itm.roomMates && itm.roomMates.length > 0)
                                                            &&
                                                            <Row className={privacyClass + " mb-3 mt-3"}>
                                                                <Col md="auto" className={"grayText"}>Previous Roommates</Col>
                                                                {
                                                                    <Col md="auto">
                                                                        {
                                                                            itm.roomMates.map((person: Person, k: number) => 
                                                                            {
                                                                                return <PersonView data={person} key={k} />;
                                                                            })
                                                                        }
                                                                    </Col>
                                                                }
                                                            </Row>
                                                        }
                                                    </div>;
                                                })
                                                :
                                                <div className="text-center" id='error'>
                                                    <br />
                                                    <p className="error-text">No Addresses available</p>
                                                </div>
                                        }
                                    </React.Fragment>
                            }
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </React.Fragment>;
    }
}

const mapStateToProps = (state: any) => ({
    role: state.app.user.role,
    settings: state.app.privacySettings
});

export default connect(mapStateToProps)(AddressView);